import { setupClickTracking } from '../../shared/clicks';

// Bootstrap page specific clicks here if need be before passing off to main click file.

export const setupSrpClickTracking = function(pageName) {
  if (!window.rdcTrackingInitialized) {
    setupClickTracking(pageName);
  }
};



// WEBPACK FOOTER //
// ./shared_critical/tracking/pages/srp/srp_clicks.js